// src/i18n/es/reconciliation.ts
// «Reconciliation view» (w7.u5) — route /reconciliation. Metric labels come
// verbatim from the API (`fin.*`, never translated at runtime); only the
// page chassis is translated here.
export const reconciliation = {
  name: 'Conciliación |||| Conciliación',
  subtitle: 'Cobros aceptados, rechazados, confirmados por el kiosco y sin confirmar, para el equipo financiero',
  provenance: 'Dato declarado por el punto de autoservicio; no contrastado con el sistema del hotel.',

  help: {
    title: 'Conciliación',
    description:
      'Los cobros del hotel: aceptados, rechazados, confirmados por el kiosco y sin confirmar, importes huérfanos, devoluciones y efectivo. «Cobros aceptados en autoservicio» cuenta solo el kiosco, el móvil y el pre-check-in online; Air Lobby, que opera el personal, queda fuera. «Confirmado por el kiosco» es lo que el punto de autoservicio declara al terminar el recorrido; todavía no se contrasta con el sistema del hotel, por eso la tasa de conciliación aparece como no disponible.',
    features: {
      list: 'Cada indicador lleva su sello de cobertura y frescura, o el remedio exacto cuando el dato no está disponible.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; el periodo por defecto son los últimos 30 días.',
    },
  },
};

export default reconciliation;
